import React, { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, ButtonText } from '@pkg/components/Sections/Profile/Buttons';
import { useWalletMutations } from '@pkg/hooks';

import { CommonSolo } from '../../components';

import { ActionsSection } from './MainDisconnect.style';

export interface MainDisconnectProps {
    walletAddress: string;
    onClose: () => void;
}

export function MainDisconnect({ walletAddress, onClose }: MainDisconnectProps) {
    // TODO: Should these translations come from the `connectWallet` file?
    const [isLoading, setIsLoading] = useState(false);
    const [translate] = useTranslation('wallet');
    const { removeWallet } = useWalletMutations();

    const handleConfirmDelete = useCallback(() => {
        setIsLoading(true);
        removeWallet({ accountAddress: walletAddress }).then(onClose);
    }, [onClose, removeWallet, walletAddress]);

    return (
        <CommonSolo
            title={translate('confirm-delete-panel-title')}
            subtitle={translate('confirm-delete-panel-description')}
        >
            <ActionsSection>
                <Button variant="solid" color="error" loading={isLoading} onClick={() => handleConfirmDelete()}>
                    {translate('confirm-delete-panel-delete')}
                </Button>

                <ButtonText disabled={isLoading} onClick={onClose}>
                    {translate('confirm-delete-panel-cancel')}
                </ButtonText>
            </ActionsSection>
        </CommonSolo>
    );
}
